import { render, staticRenderFns } from "./ClsaaRoutine.vue?vue&type=template&id=3fc19bba&"
import script from "./ClsaaRoutine.vue?vue&type=script&lang=js&"
export * from "./ClsaaRoutine.vue?vue&type=script&lang=js&"
import style0 from "./ClsaaRoutine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports